import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { DeviceProvider } from './context/deviceTypeContext';
import { SpinnerProvider } from './context/spinner/spinner';

const root = ReactDOM.createRoot(document.getElementById('root'));

const isGitHubPages = window.location.hostname.includes('github.io');
const RouterToUse = isGitHubPages ? HashRouter : BrowserRouter;
root.render(
  // <React.StrictMode>
  <RouterToUse>
    <SpinnerProvider>
      <DeviceProvider>
        <App />
      </DeviceProvider>
    </SpinnerProvider>
  </RouterToUse>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
